// extracted by mini-css-extract-plugin
export default {"closeBtn":"CloseButton_closeBtn__Zq1Ea","dark":"CloseButton_dark__CLmxR"};